import { Skeleton } from '@/components/ui/Skeleton.tsx';

export const InsuranceFormSkeleton = () => (
  <div className="space-y-4">
    {/* Nazwa input */}
    <div className="space-y-1.5">
      <Skeleton className="h-4 w-16" />
      <Skeleton className="h-10 w-full" />
    </div>

    {/* Opis textarea */}
    <div className="space-y-1.5">
      <Skeleton className="h-4 w-12" />
      <Skeleton className="h-20 w-full" />
    </div>
  </div>
);
